import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ICollection } from '../collection-schema';

export async function getPublicCollectionApi(id: number) {
  return getRequest<IAPI<ICollection>>({
    path: `/collections/${id}`,
  });
}
